import { useEffect } from 'react';
import testCasesReducer from '../store';
import testCasesSagaWatcher from '../store/sagas';
import { injectSaga } from '@app/store/rootSaga';
import { injectReducer } from '@app/store';

export const useTestcasesChunk = () => {
    useEffect(() => {
        injectReducer('testCases', testCasesReducer);
        injectSaga('testCases', testCasesSagaWatcher);
    }, []);
};
